import React from "react";
import CustomSelect from "../../../CommonElements/CustomSelect";

const CitySelect = ({ cityData, globalCityField, defaultSelectValue }) => {
  const handleSelectChange = (options) => {
    localStorage.setItem('globalCityField', JSON.stringify(options.value));
    globalCityField.onChange(options.value);
  };
  return (
    <li>
      <div className="city-select">
        <CustomSelect
          className="service-select"
          classNamePrefix="select"
          isClearable={false}
          isSearchable={false}
          onChange={handleSelectChange}
          placeholder="Select Sevice City"
          value={cityData.find((element) => {
            return element?.value?.id == globalCityField?.value?.id;
        })}
          options={cityData}
        /> 
      </div>
    </li>
  );
};

export default CitySelect;
